// test2607
(2607 && 0);
